import React from 'react';
import autobind from 'autobind-decorator';

import {StreamBankContext} from "../../../App/StreamBankContext";
import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {StreamBankLink} from "../../Common/StreamBankLink";

export class ProgramNameTableColumn extends BaseTableColumn {
    constructor() {
        super();
    }

    @autobind
    _render() {
        let context = new StreamBankContext();
        if(this.props.rowData.parentProgramId) {
            context = new StreamBankContext(
                (this.props.rowData.parentSlug || this.props.rowData.parentProgramId),
                (this.props.rowData.slug || this.props.rowData.programId)
            );
        } else {
            context = new StreamBankContext(
                (this.props.rowData.slug || this.props.rowData.programId)
            );
        }

        return <StreamBankLink
            className="sb-actionable-link"
            Tool="summary"
            Context={context}
        >
            {this.props.Value}
        </StreamBankLink>;
    }
}


